import type { ChatStreamEvent } from '@k4ia/shared'

/** Same technique as apps/web/src/lib/sse.ts — browser fetch + manual SSE framing (EventSource can't POST). */
export async function* streamChatEvents(response: Response): AsyncGenerator<ChatStreamEvent> {
  if (!response.body) throw new Error('Antwort enthält keinen Stream')
  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''

  try {
    while (true) {
      const { done, value } = await reader.read()
      if (done) break
      buffer += decoder.decode(value, { stream: true })
      let boundary: number
      while ((boundary = buffer.indexOf('\n\n')) !== -1) {
        const rawEvent = buffer.slice(0, boundary)
        buffer = buffer.slice(boundary + 2)
        const dataLine = rawEvent.split('\n').find((l) => l.startsWith('data:'))
        if (!dataLine) continue
        try {
          yield JSON.parse(dataLine.slice(5).trim()) as ChatStreamEvent
        } catch {
          // ignore malformed frame
        }
      }
    }
  } finally {
    reader.releaseLock()
  }
}
